import { Component, ChangeDetectionStrategy } from '@angular/core';
import { GoNavigationComponent } from '../../components/go-navigation/go-navigation.component';
import { AsyncPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoadingComponent } from '../../../../../../shared/components/loading/loading.component';
import { LoadingService } from '../../../../../../core/services/loading/loading.service';
import { MasqueradeHeaderComponent } from '../../../../../../shared/components/masquerade-header/masquerade-header.component';
import { GoApplicationCoordinationPageNavigationComponent } from '../../components/go-application-coordination-page-navigation/go-application-coordination-page-navigation.component';

@Component({
    selector: 'app-go-base-coordination-layout',
    imports: [
        GoNavigationComponent,
        RouterModule,
        LoadingComponent,
        AsyncPipe,
        MasqueradeHeaderComponent,
        GoApplicationCoordinationPageNavigationComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './go-base-coordination-layout.component.html',
})
export class GoBaseCoordinationLayoutComponent {
    loading$ = this.loadingService.loading$;

    constructor(private readonly loadingService: LoadingService) {}
}
